import * as Yup from 'yup';
import { filter, truncate } from 'lodash';
import { Icon } from '@iconify/react';
import { sentenceCase } from 'change-case';
import { useState, useEffect, useRef } from 'react';
import plusFill from '@iconify/icons-eva/plus-fill';
import { Link as RouterLink, useLocation } from 'react-router-dom';
// material
import { useTheme } from '@material-ui/core/styles';
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Grid,
  TextField,
  Autocomplete,
  Box,
  CircularProgress,
  Tooltip
} from '@material-ui/core';
// redux
import { useDispatch, useSelector } from 'src/redux/store';
import { getUserList, deleteUser } from 'src/redux/slices/user';
// routes
import { PATH_DASHBOARD } from 'src/routes/paths';
// components
import Page from 'src/components/Page';
import LoadingScreen from 'src/components/LoadingScreen';
import Label from 'src/components/Label';
import Scrollbar from 'src/components/Scrollbar';
import SearchNotFound from 'src/components/SearchNotFound';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import { UserListHead, UserListToolbar, UserMoreMenu } from 'src/components/_dashboard/user/list';
import  ProductToolbar  from 'src/components/_dashboard/user/list/ProductToolbar.js';
import  ProductsSearch  from 'src/components/_dashboard/blog/ProductsSearch.js';
import  ProductsMenu  from 'src/components/_dashboard/user/list/ProductsMenu.js';
import axios from 'axios';
import {REST_API, REST_API_END_POINT, UNITS} from 'src/constants/Defaultvalues';
import moment from 'moment';
import MaterialInventoryMenu from 'src/components/_dashboard/user/list/MaterialInventoryMenu';
import MaterialInventoryToolbar from 'src/components/_dashboard/user/list/MaterialInventoryToolbar';
import Modal from 'src/components/_dashboard/blog/ProjectModel';
import { Form, FormikProvider, useFormik } from 'formik';
import { LoadingButton } from '@material-ui/lab';
import { useSnackbar } from 'notistack';
import { stubTrue } from 'lodash';
import InventoryAuditLog from './InventoryAuditLog';
import InventoryStockComparison from 'src/components/_dashboard/receive-inventory/InventoryStockComparison';
import InventoryUnitCostWarningDialog from 'src/components/_dashboard/inventory/InventoryUnitCostWarningDialog';
import {
  getConvertionQtyRefillWarningContent,
  isFinishedConvertionQtyChange,
  isUnitCostOnlyChange,
} from 'src/utils/inventoryUnitCostWarning';

export default function InventoryFinishedProducts(props) {
  const theme = useTheme();
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get('id');
  const editId = parseInt(id);
  const [loading, setLoading] = useState(false)
  const [refreshData, setRefreshData] = useState(false)
  const [editFinishedProductId, setEditFinishedProductId] = useState()
  const [editData, setEditData] = useState([])
  console.log("editData :============= ",editData);
  const [openEditInventory, setOpenEditInventory] = useState(false)
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('desc');
  const [selected, setSelected] = useState([]);
  const [selectedNames, setSelectedNames] = useState([]);
  const [orderBy, setOrderBy] = useState('id');
  const [filterName, setFilterName] = useState('');
  const [filterSource, setFilterSource] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [ProductList, setProductList] = useState([]);
  const [inventoryLogData, setInventoryLogData] = useState([]);
  const receivedData = location.state?.data;
  const { enqueueSnackbar } = useSnackbar();
  const userData = JSON.parse(localStorage.getItem('user'))
  const userId = userData.user_id
  const explodedPermissions =userData?.exploded_permissions
  const [showUnitCostWarningDialog, setShowUnitCostWarningDialog] = useState(false)
  const skipUnitCostWarningRef = useRef(false)
  const [showConvertionQtyWarningDialog, setShowConvertionQtyWarningDialog] = useState(false)
  const skipConvertionQtyWarningRef = useRef(false)

  useEffect(() => {
    dispatch(getUserList());
  }, [dispatch]);

  useEffect( async () => {
    setLoading(true)
    try {
      const response = await axios.post(`${REST_API_END_POINT}product/get-finished-and-partial-products`,{editId});
      const productListData = response.data.results;
      const LogResponse = await axios.post(`${REST_API_END_POINT}product/fetch-inventory-audit-log`,{editId});
      const LogResponseData = response.data.logData;
      if(productListData){
        for (const data of productListData){
          let unit = null;
          if (data.partial){
            unit = UNITS?.filter((item)=>item.id == data.partial_unit)
            data.unit_name = unit[0]?.short_name || unit[0]?.name
          }else{
            unit = UNITS?.filter((item)=>item.id == data.unit)
            data.unit_name = unit[0]?.short_name || unit[0]?.name
          }
        }
        setProductList(productListData);
      } else{
        setProductList([]);
      }
      if(LogResponseData){
        setInventoryLogData(LogResponseData)
      } else{
        setInventoryLogData([]);
      }
    }
      catch (error) {
      console.error("Error fetching data:", error);
    }
    finally{
      setLoading(false);
    }
  }, [receivedData, refreshData]);

  const fetchDataById = async () => {
    try{
      const response = await axios.post(`${REST_API_END_POINT}product/get-finished-product-by-id`,{editFinishedProductId});
      if(response.data.status === 1) {
        setEditData(response.data.results[0])
      }
      else{
        setEditData([])
      }
    }catch(error){
      console.log(error);
    }
  }

  useEffect(()=>{
    if(editFinishedProductId){
      fetchDataById()
    }
  },[editFinishedProductId])

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
  
  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }
  
  function applySortFilter(array, comparator, query, source) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    if (query) {
      return filter(array, (_user) => _user.barcode.toLowerCase().indexOf(query.toLowerCase()) !== -1);
    }
    if (source) {
      if (source === 'Inventory') {
        return filter(array, (_user) => _user.source === 0);
      }
      else if (source === 'Vendor') {
        return filter(array, (_user) => _user.source === 1);
      }
    }
    return stabilizedThis.map((el) => el[0]);
  }
  
  const isEditingPartial = editData?.partial === 1;
  const NewCommunitySchema = Yup.object().shape({
    inventoryReason: Yup.string().required('Please enter the reason'),
    convertionUnit: Yup.object().nullable().required('Conversion unit is required'),
    unitCost: Yup.number().typeError('Please enter a valid unit cost').required('Unit cost is required'),
    ...(isEditingPartial
      ? {
          partialQty: Yup.number()
            .transform((value, originalValue) => (originalValue === '' ? undefined : value))
            .typeError('Please enter a valid qty')
            .min(0, 'Quantity must be 0 or greater')
            .notRequired(),
        }
      : {
          qty: Yup.number()
            .transform((value, originalValue) => (originalValue === '' ? undefined : value))
            .typeError('Please enter a valid qty')
            .min(0, 'Quantity must be 0 or greater')
            .notRequired(),
          convertionQty: Yup.number()
            .transform((value, originalValue) => (originalValue === '' ? undefined : value))
            .when(['convertionUnit'], {
              is: (convertionUnit) =>
                convertionUnit && convertionUnit.id !== 4 && convertionUnit.name !== 'Unit',
              then: (schema) =>
                schema
                  .typeError('Please enter a valid conversion qty')
                  .moreThan(0, 'Conversion qty must be greater than 0')
                  .required('Conversion qty is required'),
              otherwise: (schema) => schema.notRequired(),
            }),
        }),
  });
  
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      unitCost: (editFinishedProductId && editData) ? editData.unit_cost : '',
      qty:(editFinishedProductId && editData) ? (editData.unit_qty ?? '') : '',
      total:(editFinishedProductId && editData)
        ? editData.total_cost ?? (editData.unit_cost * (editData.partial === 1 ? (editData.qty ?? 0) : (editData.unit_qty ?? 0)))
        : '',
      inventoryReason:'',
      convertionUnit:
        (editFinishedProductId && editData?.convertion_unit)
          ? UNITS?.find((item) => item.id === editData.convertion_unit) || null
          : null,
      // convertionQty:(editFinishedProductId && editData) ?  editData.convertion_qty || '' : '',
      // convertionQty:(editFinishedProductId && editData) ? (editData.partial==1? editData.qty : editData.convertion_qty) || '' : '',
      convertionQty:(editFinishedProductId && editData) ? (editData.convertion_qty ?? '') : 1,
      partialQty:(editFinishedProductId && editData) ? (editData.qty ?? '') : '',
    },
    validationSchema: NewCommunitySchema,
    onSubmit: async (values, { setSubmitting, resetForm, setErrors, setFieldError }) => {
      if (
        !skipUnitCostWarningRef.current &&
        isUnitCostOnlyChange(values, editData, editFinishedProductId)
      ) {
        setShowUnitCostWarningDialog(true);
        setSubmitting(false);
        return;
      }
      skipUnitCostWarningRef.current = false;

      if (
        !skipConvertionQtyWarningRef.current &&
        isFinishedConvertionQtyChange(values, editData, editFinishedProductId)
      ) {
        setShowConvertionQtyWarningDialog(true);
        setSubmitting(false);
        return;
      }
      skipConvertionQtyWarningRef.current = false;

      try {
        const materialName = editData?.product_name
        const editBarcode = editData?.barcode
        const partial = editData?.partial
        const normalizedPartialQty = values.partialQty === '' || values.partialQty === null || values.partialQty === undefined
          ? 0
          : parseFloat(values.partialQty) || 0;
        const normalizedQty = values.qty === '' || values.qty === null || values.qty === undefined
          ? 0
          : parseFloat(values.qty) || 0;
        const normalizedTotal = editData?.partial === 1
          ? (parseFloat(values.unitCost) || 0) * normalizedPartialQty
          : values.total;
        const payloadValues = {
          ...values,
          total: normalizedTotal,
          qty: editData?.partial === 1
            ? (values?.convertionUnit?.id != 4 ? 1 : normalizedPartialQty)
            : normalizedQty,
          convertion_unit: values.convertionUnit?.id || null,
          convertion_qty: editData?.partial === 1
            ? (values?.convertionUnit?.id == 4 ? 1 : normalizedPartialQty)
            : values.convertionQty,
          convertion_total_qty: editData?.partial === 1
            ? normalizedPartialQty
            : normalizedQty * (parseFloat(values.convertionQty) || 0),
        };
        const response = await axios.post(`${REST_API_END_POINT}product/update-inventory`, {
          values: payloadValues,
          userId,
          editFinishedProductId,
          editId,
          materialName,
          editBarcode,
          partial,
          auditTotalQtyLabel:
            editData?.partial === 1 && values?.convertionUnit?.short_name
              ? `Total ${values.convertionUnit.short_name} Qty`
              : undefined,
          auditFinishedTotalQtyLabel:
            editData?.partial !== 1 && values?.convertionUnit?.short_name
              ? `Total ${values.convertionUnit.short_name} Qty`
              : undefined,
        })
        console.log("Edit inventory response : ", response.data);
        if (response.data.status === 1) {
          enqueueSnackbar(response.data.message, { variant: 'success' });
          resetForm();
          setSubmitting(false);
          setOpenEditInventory(false)
          setEditData([])
          setEditFinishedProductId()
          setRefreshData(!refreshData)
        }
        else {
          enqueueSnackbar(response.data.message, { variant: 'error' });
        }
      } catch (error) {
        console.error("Error : ", error);
        setSubmitting(false);
        setErrors(error);
      }
    }
  });
  
  const { errors, values, touched, handleSubmit, isSubmitting, setFieldValue, getFieldProps, submitForm } = formik;

  const handleConfirmUnitCostWarning = () => {
    setShowUnitCostWarningDialog(false);
    skipUnitCostWarningRef.current = true;
    submitForm();
  };

  const handleConfirmConvertionQtyWarning = () => {
    setShowConvertionQtyWarningDialog(false);
    skipConvertionQtyWarningRef.current = true;
    submitForm();
  };

  const convertionQtyWarningContent = getConvertionQtyRefillWarningContent(values, editData);

  const isBaseConversionUnit = values?.convertionUnit?.id === 4 || values?.convertionUnit?.name === 'Unit';
  const shouldShowConversionQtyFields = !!values?.convertionUnit && !isBaseConversionUnit;
  const unitName = ProductList[0]?.unit_name || '';
  const unitQty = editData?.unit_qty || ProductList[0]?.unit_qty || 1;

  useEffect(() => {
    if (!isBaseConversionUnit) return;
    if (parseInt(values.convertionQty, 10) !== 1) setFieldValue('convertionQty', 1);
  }, [isBaseConversionUnit, values.convertionQty, setFieldValue]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = slicedData?.map((n) => n.id);
      const newSelectedNames = slicedData?.map((n) => n.name);
      setSelected(newSelecteds);
      setSelectedNames(newSelectedNames);
      return;
    }
    setSelected([]);
    setSelectedNames([]);
  };

  const handleClick = (event, id,name) => {
    const selectedIndex = selected?.indexOf(id);
    const selectedNameIndex = selectedNames?.indexOf(name);
    let newSelected = [];
    let newselectedNames = [];
    if (selectedIndex === -1) {
      newSelected = newSelected?.concat(selected, id);
      newselectedNames = newselectedNames?.concat(selectedNames, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected?.concat(selected?.slice(1));
      newselectedNames = newselectedNames?.concat(selectedNames?.slice(1));
    } else if (selectedIndex === selected?.length - 1) {
      newSelected = newSelected?.concat(selected?.slice(0, -1));
      newselectedNames = newselectedNames?.concat(selectedNames?.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected?.concat(selected?.slice(0, selectedIndex), selected?.slice(selectedIndex + 1));
      newselectedNames = newselectedNames?.concat(selectedNames?.slice(0, selectedNameIndex), selectedNames?.slice(selectedNameIndex + 1));
    }
    setSelected(newSelected);
    setSelectedNames(newselectedNames);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setSelected([]);
    setSelectedNames([]);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
    setPage(0)
  };

  const handleFilterBySource = (event) => {
    setFilterSource(event);
    setPage(0)
  };

  const handleDeleteUser = (userId) => {
    dispatch(deleteUser(userId));
  };

  // ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'barcode', label: 'Barcode', alignRight: false },
//   { id: 'name', label: 'Name', alignRight: false },
  // { id: 'unit_cost', label: `${ProductList[0]?.unit_name} Cost`, alignRight: false },
  { id: 'unit_cost', label: 'Unit Cost', alignRight: false },
  // { id: 'qty', label: `Total ${ProductList[0]?.unit_name}`, alignRight: false },
    { id: 'qty', label: 'Total Qty', alignRight: false },
  // { id: 'total_cost', label: 'Total Cost', alignRight: false },
  { id: 'source', label: 'Source', alignRight: false },
  { id: 'vendor', label: 'Vendor', alignRight: false },
  // { id: 'authorized_by', label: 'Added By', alignRight: false },
  // { id: 'timestamp', label: 'Added On', alignRight: false },
  // { id: 'status', label: 'Status', alignRight: false },
  { id:'options', label: '', alignRight: false},      
];

// ----------------------------------------------------------------------

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - ProductList?.length) : 0;
  const filteredUsers = applySortFilter(ProductList, getComparator(order, orderBy), filterName, filterSource);
  const slicedData = filteredUsers?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  const isUserNotFound = filteredUsers?.length === 0;

  const handleNumberInputKeyDown = (e) => {
    const invalidKeys = ['e', 'E', '+', '-', 'ArrowUp', 'ArrowDown'];
    if (invalidKeys.includes(e.key)) {
      e.preventDefault();
    }
  };

  const handleCloseEditInventory = () => {
    setOpenEditInventory(false);
    setShowUnitCostWarningDialog(false);
    setShowConvertionQtyWarningDialog(false);
    skipUnitCostWarningRef.current = false;
    skipConvertionQtyWarningRef.current = false;
    formik.resetForm();
    setEditData([]);
    setEditFinishedProductId();
  };

  return (
    <>
      <Container>
        <Card>
          <MaterialInventoryToolbar 
            numSelected={selected?.length} 
            filterName={filterName} 
            onFilterName={handleFilterByName}
            filterSource={filterSource}
            onFilterSource={handleFilterBySource}
            selectedName={selectedNames} 
            selected={selected} 
            onDelete={() => {setSelected([]);setPage(0);}}
            item="barcode"
            inventoryAudit={true}
          />
          <InventoryStockComparison materialId={editId} refreshData={refreshData} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={slicedData?.length}
                  numSelected={selected?.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                {loading ? (
                  // <CircularProgress color="primary" variant="indeterminate" />
                  <Stack sx={{alignItems:'center', justifyContent:'center', minWidth: 800}}>
                    <LoadingScreen />
                  </Stack>
                ) : (
                  <>
                  {slicedData?.map((row) => {
                    let { id,	barcode, partial, name, timestamp, status, unit_name, unit_cost,qty,unit_qty,total_cost,vendor, authorized_by,source,convertion_unit } = row;
                    const isWithinLast24Hours = (timestamp) => {
                      const twentyFourHoursAgo = moment().subtract(24, 'hours');
                      const timestampMoment = moment.unix(timestamp); // Convert timestamp to moment object
                      return timestampMoment.isAfter(twentyFourHoursAgo);
                    };
                    const withinLast24Hours = isWithinLast24Hours(timestamp);
                    const isItemSelected = selected?.indexOf(id) !== -1;
                     const convertionUnitName = convertion_unit ? UNITS?.find((item) => item.id === convertion_unit)?.short_name : 'Unit';
                    const hasParentFinishedProduct = row.parent_finished_product_id != null && row.parent_finished_product_id !== '';
                    const isUnlinkedRow = partial ? !hasParentFinishedProduct : false;
                    const defaultTextColor = theme.palette.mode === 'light' ? '#ff5b78' : '#ffc0cb';
                    const cellColor = partial ? (isUnlinkedRow ? theme.palette.text.primary : defaultTextColor) : (theme.palette.mode === 'light' ? "#9c7d7d" : '#ffffff');
                    const unlinkedRowBg = theme.palette.mode === 'light' ? 'rgba(255, 235, 59, 0.22)' : 'rgba(255, 193, 7, 0.16)';

                    return (
                      <TableRow
                        hover={!isUnlinkedRow}
                        key={id}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                        sx={
                          isUnlinkedRow
                            ? {
                                backgroundColor: unlinkedRowBg,
                                boxShadow: `inset 3px 0 0 ${theme.palette.warning.main}`,
                                '&:hover': { backgroundColor: unlinkedRowBg },
                                '&.Mui-selected': { backgroundColor: unlinkedRowBg },
                                '&.Mui-selected:hover': { backgroundColor: unlinkedRowBg },
                              }
                            : undefined
                        }
                      >
                        <TableCell>
                          {/* <Checkbox checked={isItemSelected} onChange={(event) => handleClick(event, id,name)} /> */}
                          {withinLast24Hours && <Label
                            variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                            color={ 'info' }
                          >
                            New
                          </Label>}
                        </TableCell>
                        <TableCell align="center">
                          {/* <Barcode value={barcode} width={0.5} height={30} fontSize={10}/> */}
                          <Typography variant="body" sx={{color: cellColor}}>
                          {barcode}
                          </Typography>
                        </TableCell>
                        {/* <TableCell component="th" scope="row" padding="none">
                          <Stack direction="row" alignItems="center" justifyContent="center" spacing={2}>
                            <Typography variant="subtitle2" noWrap>
                              {name}
                            </Typography>
                          </Stack>
                        </TableCell> */}
                        <Tooltip title={unit_cost ? unit_cost : "0.00"}><TableCell align="center" sx={{color: cellColor}}>{unit_cost ? unit_cost?.toFixed(2) : 0.00}</TableCell></Tooltip>
                        {/* <TableCell align="center" sx={{color: partial ? "#ffc0cb" : '#ffffff'}}>{qty} {unit_name}</TableCell> */}
                        {/* <TableCell align="center" sx={{color: partial ? "#ffc0cb" : '#ffffff'}}>{partial ? `${qty ? qty?.toFixed(2) : 0.00} ${unit_name}` : `${unit_qty ? unit_qty?.toFixed(2) : 0.00} ${convertionUnitName ? `(${qty ? qty?.toFixed(2) : 0.00} ${convertionUnitName})` : ''}` }</TableCell> */}
                        <TableCell align="center" sx={{color: cellColor}}>{partial ? `${qty ? qty?.toFixed(2) : 0.00} ${convertionUnitName}` : `${unit_qty ? unit_qty?.toFixed(2) : 0.00} ${convertionUnitName ? `(${qty ? qty?.toFixed(2) : 0.00} ${convertionUnitName})` : ''}` }</TableCell>
                        {/* <TableCell align="center">{total_cost}</TableCell> */}
                        <TableCell align="center" sx={{color: cellColor}}>{source === 0 ? 'Inventory' : 'Vendor'}</TableCell>
                        <TableCell align="center" sx={{color: cellColor}}>{vendor}</TableCell>
                        {/* <TableCell align="center">{authorized_by}</TableCell>
                        <TableCell align="center">{moment.unix(timestamp).format('DD-MM-YYYY')}</TableCell> */}
                        {/* <TableCell align="center">
                          <Label
                            variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                            color={(status === 1 && 'info') || 'error'}
                          >
                            {sentenceCase((status === 1) ? "Active" : "Inactive")}
                          </Label>
                        </TableCell> */}

                        <TableCell align="center">
                          {(explodedPermissions?.some(permission => ['Edit Inventory'].includes(permission)))
                          ?
                            <MaterialInventoryMenu
                            userName={name}
                            id={id}
                            status={status}
                            fromFinishedProducts
                            fromInventoryAudit
                            onEdit={(id)=>{setEditFinishedProductId(id);setOpenEditInventory(true) }}
                            onRefresh={()=>{setRefreshData(!refreshData)}} 
                            partial={partial}
                            editId={editId}
                            />
                            : null
                          }
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                  </>
                    )}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={10} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} msg="Item"/>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            // rowsPerPageOptions={[5, 10, 25]}
            rowsPerPageOptions={[10, 25, 50, 100]}
            component="div"
            count={filteredUsers?.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
        <InventoryAuditLog refreshData={refreshData}/>
      </Container>
      <Modal
        modalTitle={'Edit Inventory'}
        open={openEditInventory}
        handleClose={handleCloseEditInventory}
      >
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container spacing={3} justifyContent="center">
              <Grid item xs={12} md={8}>
                <Stack spacing={3}>
                  <Stack direction={{ xs: 'column', sm: 'column' }} spacing={{ xs: 3, sm: 2 }}>
                    <TextField
                      fullWidth
                      // label={unitName ? unitName + ' Cost ($)' : 'Unit Cost ($)'}
                      label={'Unit Cost ($)'}
                      type="number"
                      // onKeyPress={(event) => {
                      //   if (event.key === '-' ) {
                      //     event.preventDefault();
                      //   }
                      //   if (event.key === '+' ) {
                      //     event.preventDefault();
                      //   }
                      // }}
                      // onWheel={(e) => e.target.blur()}
                      // onKeyDown={(event) => {
                      //   const value = parseFloat(event.target.value) || 0;
                      //   if (event.key === 'ArrowDown' && value <= 0) {
                      //     event.preventDefault();
                      //   }
                      // }}
                      // InputProps={{ readOnly: editData?.partial }}
                      InputLabelProps={{ shrink: true }}
                      onKeyDown={handleNumberInputKeyDown}
                      value={values.unitCost}
                      onChange={(e)=>{
                        setFieldValue('unitCost', e.target.value);
                        const qtyForTotal = editData?.partial === 1
                          ? (parseFloat(values.partialQty) || 0)
                          : (parseFloat(values.qty) || 0);
                        setFieldValue('total', e.target.value * qtyForTotal);
                      }}
                      error={Boolean(touched.unitCost && errors.unitCost)}
                      helperText={touched.unitCost && errors.unitCost}
                    />
                    {/* {unitName === 'Unit' ? null :
                    <TextField
                      fullWidth
                      label={'Number of '+unitName}
                      type="number"
                      value={unitQty || 0}
                      error={Boolean(touched.unit_qty && errors.unit_qty)}
                      helperText={touched.unit_qty && errors.unit_qty}
                      InputProps={{ readOnly:true }}
                    />} */}
                    {(editData?.partial === 0) && (<TextField
                      fullWidth
                      label="Quantity"
                      type="number"
                      onKeyPress={(event) => {
                        if (event.key === '-') {
                          event.preventDefault();
                        }
                        if (event.key === '+') {
                          event.preventDefault();
                        }
                        if (event.key === '.' || event.key === 'e' || event.key === 'E') {
                          event.preventDefault();
                        }
                      }}
                      onWheel={(e) => e.target.blur()}
                      onKeyDown={(event) => {
                        const value = parseFloat(event.target.value) || 0;

                        if (event.key === 'ArrowDown' && value <= 0) {
                          event.preventDefault();
                        }
                      }}
                      value={values.qty}
                      InputLabelProps={{ shrink: true }}
                      onChange={(e) => {
                        const qtyValue = parseInt(e.target.value, 10);
                        const finalQty = Number.isNaN(qtyValue) ? '' : qtyValue;
                        setFieldValue('qty', finalQty);
                        // if(unitName === 'Unit') {
                        setFieldValue('total', (values.unitCost * (Number.isNaN(qtyValue) ? 0 : qtyValue)))
                        // }else{
                        //   setFieldValue('total',(values.unitCost * (unitQty * (Number.isNaN(qtyValue) ? 0 : qtyValue)))?.toFixed(2))
                        // }
                      }}
                      error={Boolean(touched.qty && errors.qty)}
                      helperText={touched.qty && errors.qty}
                    />
                    )}
                    <Autocomplete
                      fullWidth
                      id="inventory-conversion-unit"
                      options={UNITS}
                      value={values.convertionUnit}
                      onChange={(event, newValue) => {
                        setFieldValue('convertionUnit', newValue);
                        if (newValue?.id === 4 || newValue?.name === 'Unit') {
                          setFieldValue('convertionQty', 1);
                        } else if (!editFinishedProductId) {
                          setFieldValue('convertionQty', 1);
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          required
                          label="Select a conversion unit"
                          error={Boolean(touched.convertionUnit && errors.convertionUnit)}
                          helperText={touched.convertionUnit && errors.convertionUnit}
                        />
                      )}
                      getOptionLabel={(option) => option?.name ? option.name : ''}
                      disabled={editData?.partial}
                      // disabled={true}
                    />
                    {(shouldShowConversionQtyFields && editData?.partial==0) && (
                      <>
                        <TextField
                          fullWidth
                          required
                          label={values.convertionUnit ? `${values.convertionUnit?.short_name} Qty ${editData?.partial==0?'each':''} ` : `Conversion Qty ${editData?.partial==0?'each':''}`}
                          type="number"
                          inputProps={{ step: 1, min: 1 }}
                          onKeyPress={(event) => {
                            if (
                              event.key === '-' ||
                              event.key === '+' ||
                              event.key === 'e' ||
                              event.key === 'E' ||
                              event.key === '.'
                            ) {
                              event.preventDefault();
                            }
                          }}
                          onKeyDown={(event) => {
                            if (event.key === '-' || event.key === 'Subtract') {
                              event.preventDefault();
                            }
                            const currentValue = parseInt(event.target.value, 10) || 0;
                            if (event.key === 'ArrowDown' && currentValue <= 1) {
                              event.preventDefault();
                            }
                          }}
                          value={values.convertionQty}
                          onChange={(e) => {
                            const raw = e.target.value;
                            if (raw === '') {
                              setFieldValue('convertionQty', '');
                              return;
                            }
                            if (/^-/.test(raw)) {
                              return;
                            }
                            const parsedValue = parseInt(raw, 10);
                            if (Number.isNaN(parsedValue) || parsedValue <= 0) {
                              return;
                            }
                            setFieldValue('convertionQty', parsedValue);
                          }}
                          error={Boolean(touched.convertionQty && errors.convertionQty)}
                          helperText={touched.convertionQty && errors.convertionQty}
                        />                     
                        {editData?.partial==0 && <TextField
                          fullWidth
                          label={values.convertionUnit ? ` Total ${values.convertionUnit?.short_name} Qty` : 'Total Qty'}
                          type="number"
                          value={(parseInt(values.qty, 10) || 0) * (parseInt(values.convertionQty, 10) || 0)}
                          InputProps={{ readOnly: true }}
                        />}
                      </>
                    )}
                    {editData?.partial==1 && <TextField
                      fullWidth
                      label={values.convertionUnit ? ` Total ${values.convertionUnit?.short_name} Qty` : 'Total Qty'}
                      type="number"
                      inputProps={{ min: 0, step: 1 }}
                      value={values.partialQty === '' || values.partialQty === null || values.partialQty === undefined ? '' : values.partialQty}
                      onKeyPress={(event) => {
                        if (event.key === '-' || event.key === '+' || event.key === 'e' || event.key === 'E' || event.key === '.') {
                          event.preventDefault();
                        }
                      }}
                      onKeyDown={(event) => {
                        if (event.key === '-' || event.key === 'Subtract') {
                          event.preventDefault();
                        }
                        const currentValue = parseInt(event.target.value, 10) || 0;
                        if (event.key === 'ArrowDown' && currentValue <= 0) {
                          event.preventDefault();
                        }
                      }}
                      onChange={(e) => {
                        const raw = e.target.value;
                        if (raw === '') {
                          setFieldValue('partialQty', '');
                          setFieldValue('total', 0);
                          return;
                        }
                        if (/^-/.test(raw)) {
                          return;
                        }
                        const parsedValue = parseInt(raw, 10);
                        if (Number.isNaN(parsedValue) || parsedValue < 0) {
                          return;
                        }
                        setFieldValue('partialQty', parsedValue);
                        setFieldValue('total', (parseFloat(values.unitCost) || 0) * parsedValue);
                      }}
                      error={Boolean(touched.partialQty && errors.partialQty)}
                      helperText={touched.partialQty && errors.partialQty}
                    />}
                    <TextField
                        fullWidth
                        label="Total Cost ($)"
                        type="number"
                        {...getFieldProps('total')}
                        InputLabelProps={{ shrink: true }}
                        error={Boolean(touched.total && errors.total)}
                        helperText={touched.total && errors.total}
                        InputProps={{ readOnly:true }}
                    />
                  {/* // include cost per unit */}
                  {
                    editData?.partial== 0 ?
                  
                  <TextField
                      fullWidth
                      label="Cost per Unit"
                      type="number"
                      disabled
                      value={
                        Number(((parseFloat(values.total) || 0) /
                        (((parseFloat(values.qty) || 0) * (parseFloat(values.convertionQty) || 0)) || 1)).toFixed(2))
                      }
                      InputProps={{ readOnly: true }}
                  />
                  : null}
                    
                    <TextField
                        fullWidth
                        label="Reason"
                        {...getFieldProps('inventoryReason')}
                        error={Boolean(touched.inventoryReason && errors.inventoryReason)}
                        helperText={touched.inventoryReason && errors.inventoryReason}
                    />
                  </Stack>

                  <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                    <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
                      {'Save Changes'}
                    </LoadingButton>
                    <Button variant="outlined" onClick={handleCloseEditInventory} sx={{ marginLeft: '10px' }}>
                      Cancel
                    </Button>
                  </Box>
                </Stack>
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </Modal>
      <InventoryUnitCostWarningDialog
        open={showUnitCostWarningDialog}
        onClose={() => setShowUnitCostWarningDialog(false)}
        onConfirm={handleConfirmUnitCostWarning}
      />
      <InventoryUnitCostWarningDialog
        open={showConvertionQtyWarningDialog}
        onClose={() => setShowConvertionQtyWarningDialog(false)}
        onConfirm={handleConfirmConvertionQtyWarning}
        title={convertionQtyWarningContent.title}
        message={convertionQtyWarningContent.message}
        continueQuestion={convertionQtyWarningContent.continueQuestion}
        highlightText={convertionQtyWarningContent.highlightText}
      />
    </>
  );
}
